{
  "ancillaries": {
    "bundle": {
      "extraTitle": "Tuotepaketit",
      "toggle": {
        "title": "Lisää Istuinpaikka + Internet-yhteys",
        "description": {
          "WIAL": "Yhdistä istuinpaikkasi ja <b>Browse-paketti koko lennon ajaksi</b>.",
          "WIEF": "Yhdistä istuinpaikkasi ja <b>Stream-paketti koko lennon ajaksi</b>."
        },
        "notAvailableNotification": "Tätä comboa ei ole saatavilla valitsemallesi istuinpaikalle"
      },
      "serviceIncludedInBundleNotification": "Matkustajalla on jo valittuna combo-paketti, joka sisältää internet-yhteyden."
    },
    "toaster": {
      "errorSavingBundle": "Tekemiäsi muutoksia tuotepaketteihin ei pystytty tallentamaan. Ole hyvä ja yritä uudelleen."
    },
    "seat": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, seats <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, seats <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "meals": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, meals <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, meals <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "lounge": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, lounge <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, lounge <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "wifi": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, internet <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, internet <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "bags": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "cabinBaggage": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, bags <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "pet": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, pets <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, pets <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    },
    "sport": {
      "eligibility": {
        "notAvailableBus": "Unfortunately, sports equipment <b>cannot be added for this part of your journey on our site</b> because this is a bus connection.",
        "notAvailableTrain": "Unfortunately, sports equipment <b>cannot be added for this part of your journey on our site</b> because this is a train connection."
      }
    }
  },
  "services": {
    "seat": {
      "bundleNotification": "<b>Istuinpaikka + Internet-yteys</b> -combo saatavilla",
      "bundleUnavailableSeatConfirmModal": {
        "title": "Lisää istuinpaikka + internet-yhtyes",
        "firstContentParagraph": "Valitsemasi istuinpaikka ei ole saatavilla combona.",
        "secondContentParagraph": "<b>Näyttääksemme saatavilla olevat combo tarjoukset</b> me poistamme nykyisen istuinpaikkasi.",
        "closeButton": "Peru",
        "continueButton": "Näytä tarjoukset"
      }
    },
    "wifi": {
      "bundleRemovalConfirmModal": {
        "title": "Poista combo",
        "firstContentParagraph": "Jos haluat valita toisen Internet-yhteyspaketin tai poistaa aiemmin valitsemasi <b>Istuinpaikka + Internet-yhteys combon</b> istuinpaikkasi päivitetään alkuperäiseen yksittäishintaan.</b>",
        "secondContentParagraph": "Haluatko jatkaa?",
        "closeButton": "Takaisin",
        "continueButton": "Jatka"
      }
    }
  },
  "upsellCard": {
    "description": {
      "genericLongHaul": "Compare the meal service, seats and entertainment in different travel classes on long-haul flights."
    },
    "modalLink": {
      "allClasses": "Travel class differences"
    }
  },
  "routeNotification": {
    "trainConnections": {
      "link": {
        "url": "#"
      }
    },
    "containsTrainSegment": {
      "link": {
        "url": "#"
      }
    }
  },
  "purchase": {
    "review": {
      "containsTrainNotification": {
        "link": {
          "url": "#"
        }
      }
    },
    "payment": {
      "bundleCount": "Combo x {bundleCount}"
    }
  },
  "upsellPromotion": {
    "totalPriceInfo": "Hinta yhteensä kaikilta matkustajilta",
    "selected": "Valittu",
    "changeToClassic": "Vaihda Classic-lippuun",
    "continueWithLight": "Jatka Light-lipulla",
    "continueWithSuperLight": "Continue with Superlight"
  }
}
